import React from "react";
import { Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Header } from "../../Shared";
import { Array, LandingPage, BigPicturePages } from "../../../helper";
import { setSelect } from "../../../store/stylesSlice";

import "../../../assets/stlyes/BigPicture/BigPictureLanding.scss"

import Curiculum from "../../../assets/images/CurriculumCoverage.png"
import PassRate from "../../../assets/images/PredictedPassRate.svg"
import Predictions from "../../../assets/images/EndOfYearPrediction.png"
import Demographics from "../../../assets/images/Demographics.png"
import Progress from "../../../assets/images/Progress.png"
import StrengthAnalysis from "../../../assets/images/SubjectAreaAnalysis.png"
import { Tooltip } from "@mui/material";

const LandingPageBigPic = () => {
  const navigate = useNavigate();
  let imageArray = [Curiculum, PassRate, Predictions, Demographics, Progress, StrengthAnalysis]
  const dispatch = useDispatch();
  dispatch(setSelect("Big Picture"));
  const handleNavigate = (i) => {
    switch (i) {
    case 0:
      navigate(BigPicturePages.curriculumCoverage);
      break;
    case 1:
      navigate(BigPicturePages.bigPictuePredictedProgress);
      break;
    case 2:
      navigate(BigPicturePages.bigPictueEndOfYearPrediction);
      break;
    case 3:
      navigate(BigPicturePages.demographics);
      break;
    case 4:
      navigate(BigPicturePages.progress);
      break;
    default:
      break;
    }
  };

  return (
    <div className="Page-layout">
      <div className="Page-header">
        <Header />
        <div className="Page-body margin" style={{ paddingRight: "75px" }}>
          <div className="headingBP">
            <div className="heading-1">
              {LandingPage.BigPicture}
            </div>
            <div className="heading-2">
              {LandingPage.AnalyseData}
            </div>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", marginTop: "300px" }}>
            {Array.BigPicture.map((big, i) => {
              return (
                <div key={i} onClick={() => { handleNavigate(i) }} onKeyDown={(e) => { e.key === "Enter" && handleNavigate(i) }} role="button" tabIndex={0} style={{ width: "360px" }}>
                  <Card className="mainCard" >
                    <Card.Title className="landing-card-title" >{big}</Card.Title>
                    <Card.Body className="bigPictureCard">
                      {i !== 5 ? <Card.Img className={Array.classNames[i]} variant="top" src={imageArray[i]} /> :
                        <Tooltip title={i == 5 ? "Coming soon!" : ""} placement="top">
                          <Card.Img className={Array.classNames[i]} variant="top" src={imageArray[i]} />
                        </Tooltip>}
                    </Card.Body>
                  </Card>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )

}

export { LandingPageBigPic }